<template>
    <div class="pay-channel-list">
        <div class="row">
            <pay-channel-item
                v-for="item in outerPayChannels"
                :key="item.channel"
                :checked="value === item.channel"
                :show-radio="showRadio"
                :pay-channel="item.channel"
                :disabled="item.disabled"
                @change="handleChange"
            />
        </div>
        <div class="row">
            <pay-channel-item
                v-for="item in innerPayChannels"
                :key="item.channel"
                :checked="value === item.channel"
                :show-radio="showRadio"
                :pay-channel="item.channel"
                :disabled="item.disabled"
                @change="handleChange"
            />
        </div>
    </div>
</template>

<script>
import PayChannelItem from './components/pay-channel-item';

export default {
    name: 'SyPayChannelList',
    components: {
        PayChannelItem
    },
    props: {
        // 所有支付渠道
        payChannels: {
            type: Array,
            default: () => [
                // 银联
                'UNION',
                // 银联商务公众号支付
                'CHINAUMS_OFFICIAL',
                // 银联商务扫码支付
                'CHINAUMS_SCAN',
                // 银联商务微信小程序
                'CHINAUMS_WX_MINI',
                // 银联商务APP微信
                'CHINAUMS_WX_APP',
                // 银联商务电子账户零钱
                'UNION_CHANGE',
                // 结算宝钱包
                'JSB_WALLET',
                // 授信
                'CREDIT'
            ]
        },
        // 是否显示单选框
        showRadio: {
            type: Boolean,
            default: true
        },
        // 当前支付渠道
        value: {
            type: String,
            default: ''
        }
    },
    computed: {
        /**
         * 内部支付渠道
         */
        innerPayChannels() {
            const res = [];
            for (let i = 0; i < this.payChannels.length; i++) {
                if (
                    this.payChannels[i] === 'CHANGE' ||
                    this.payChannels[i] === 'CREDIT' ||
                    this.payChannels[i] === 'SXOPENAPI'
                ) {
                    res.push({
                        channel: this.payChannels[i],
                        disabled: false
                    });
                }
            }
            return res;
        },
        /**
         * 外部支付方式
         */
        outerPayChannels() {
            const res = [];
            for (let i = 0; i < this.payChannels.length; i++) {
                if (
                    this.payChannels[i] !== 'CHANGE' &&
                    this.payChannels[i] !== 'CREDIT' &&
                    this.payChannels[i] !== 'SXOPENAPI'
                ) {
                    res.push({
                        channel: this.payChannels[i],
                        disabled: false
                    });
                }
            }
            return res;
        }
    },
    methods: {
        /**
         * 处理点击事件
         */
        handleChange(event) {
            this.$emit('input', event);
        }
    }
};
</script>

<style lang="scss" scoped>
.pay-channel-list {
    .row {
        display: flex;
        flex-wrap: wrap;
    }

    .pay-channel-item {
        margin: 0 23px 23px 0;
    }
}

@media only screen and (max-width: 800px) {
    .pay-channel-list {
        min-width: 200px;
    }
}
</style>
